<p-dialog
  [(visible)]="visible"
  header="{{ 'information.announcements.title' | translate }}"
  [style]="{ 'min-width': '40vw', 'max-width': '80vw' }"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  contentStyleClass="p-0"
  (onHide)="onClose()">
  <div *ngFor="let announcement of announcements">
    <div class="bg-gray-200 px-6 py-4 text-base font-semibold">
      {{ announcement.title }}
    </div>
    <div class="px-6" [innerHTML]="announcement.content"></div>
    <div class="px-6 py-4">
      <i class="fa-regular fa-calendar mr-1 text-gray-600"></i>
      {{ announcement.period }}
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-start">
      <button type="button" pButton label="{{ 'common.button.close' | translate }}" (click)="onClose()"></button>
    </div>
  </ng-template>

  <ng-template pTemplate="closeicon">
    <div
      class="p-dialog-header-icon"
      [title]="
        'dialog.button.close'
          | translate
            : {
                '0': 'information.announcements.title' | translate
              }
      ">
      <i class="fa-regular fa-xmark text-lg text-gray-800"></i>
    </div>
  </ng-template>
</p-dialog>
